import { useAppState } from '@/app/useAppState';
import { LOCALES, type Locale } from '@/domain/ids';
import { useI18n } from '@/i18n/context';
import { cn } from '@/lib/cn';

export const LOCALE_NAMES: Record<Locale, string> = {
  ar: 'العربيّة',
  fr: 'Français',
  en: 'English',
};

/** Device language switcher (used before a learner is chosen). */
export function LanguagePicker({ className }: { className?: string }) {
  const { settings, updateSettings, activeLearner, updatePreferences } = useAppState();
  const { t, locale } = useI18n();
  const change = (next: Locale) =>
    activeLearner ? updatePreferences({ locale: next }) : updateSettings({ locale: next });
  return (
    <div
      role="group"
      aria-label={t('settings.language')}
      className={cn(
        'inline-flex gap-1 rounded-full bg-surface p-1 shadow-[var(--shadow-card)]',
        className,
      )}
    >
      {LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          lang={code}
          aria-pressed={(activeLearner ? locale : settings.locale) === code}
          onClick={() => void change(code)}
          className={cn(
            'min-h-10 rounded-full px-3 text-sm font-bold',
            (activeLearner ? locale : settings.locale) === code
              ? 'bg-brand-700 text-white'
              : 'text-ink-muted hover:bg-surface-muted',
          )}
        >
          {LOCALE_NAMES[code]}
        </button>
      ))}
    </div>
  );
}
